<div *ngIf="!isLoaded" class="no-user-content">
    <img alt="Loading" src="/assets/img/loader.gif" class="loader-gif-xs" />
    <span>{{ 'powerBiReport.loading' | translate }}</span>
</div>
<div class="btn-container" *ngIf="showReport">
    <button
        [disabled]="isExportInProgress | async"
        [ngClass]="{ 'export-in-progress': isExportInProgress | async }"
        class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
        (click)="downloadReportAsPDF()">
        <svg-icon
            *ngIf="!(isExportInProgress | async)"
            icon="export"></svg-icon>
        <span
            [translate]="
                (isExportInProgress | async)
                    ? 'powerBiReport.downloading'
                    : 'powerBiReport.exportReport'
            "></span>
    </button>
</div>
<div [hidden]="!showReport" id="reportContainer"></div>
<div *ngIf="showNoUserContent" class="no-user-content">
    <span>{{ 'powerBiReport.userNotExistMsg' | translate }}</span>
</div>
<div *ngIf="showNoOrgAssociateContent" class="no-user-content">
    <span>{{ 'powerBiReport.noOrgAssociateMsg' | translate }}</span>
</div>
